import React, { useEffect, useMemo } from 'react';
import { colorPalette } from '@sharefiledev/antd-config';
import { Flex, theme, Typography } from 'antd';
import { ComponentTypes, getAnnotationFields } from '../../../../common/componentUtils';
import { t } from '../../../../utils';
import { FieldsSection } from '../FieldsSection';

interface Props {
	selectedField: ComponentTypes | null;
	onSelectField: (type: ComponentTypes | null) => void;
	onSelectTab: (value: string) => void;
}

const { Text, Title } = Typography;

export const Annotations = ({ selectedField, onSelectField, onSelectTab }: Props) => {
	const { token } = theme.useToken();
	useEffect(() => {
		onSelectTab(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const annotations = useMemo(() => {
		// eslint-disable-next-line @typescript-eslint/no-shadow
		const annotations = getAnnotationFields();
		return annotations.map(annotationValues => ({
			...annotationValues,
			color: colorPalette.neutral13,
		}));
	}, []);
	return (
		<Flex vertical gap={token.size}>
			<Flex vertical gap="small">
				<Title style={{ margin: 0 }} level={5}>
					{t('leftNav.annotateDocument')}
				</Title>
				<Text style={{ fontSize: token.fontSizeSM }}>
					{t('leftNav.annotateDescription')}
				</Text>
			</Flex>
			<FieldsSection>
				<FieldsSection.Fields
					fields={annotations}
					selectedField={selectedField}
					onClick={onSelectField}
				/>
			</FieldsSection>
		</Flex>
	);
};
